import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import Right from '../../images/icons/Gray_Right.svg';
import Left from '../../images/icons/Gray_Left.svg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import TwoColumnLogoQuote from '../quote/TwoColumnLogoQuote';
import CarouselV2 from './CarouselV2';

const QuoteSlideWrapper = styled.div`
	.slick-list {
		padding-bottom: 44px;
	}

	.slick-dots li {
		margin: 0 0px;

		button:before {
			font-size: 8px;
		}
	}
`;

const quoteComponent = {
	logoQuote: content => {
		return (
			<TwoColumnLogoQuote
				overline={'trusted by your peers'}
				quote={content.quote.quote}
				bioPhoto={
					content?.quoteSourceBioPhoto?.file?.url ||
					content?.quoteAuthor?.authorBioPhoto?.file.url
				}
				bioName={content?.quoteSource || content?.quoteAuthor?.authorName}
				bioTitle={
					content?.quoteSourceJobTitle || content?.quoteAuthor?.authorJobTitle
				}
				bioLogo={
					content?.sourceCompanyLogo?.file?.url ||
					content?.quoteAuthor?.authorCompanyLogo?.file.url
				}
			/>
		);
	},
};

const BasicQuoteSlide = ({ testimonialList, quoteType }) => {
	return (
		<QuoteSlideWrapper className="slider-container">
			<CarouselV2
				slides={testimonialList.map(testimonial => {
					return <div>{quoteComponent[quoteType](testimonial)}</div>;
				})}
				dots
				autoPlay
				speed={7000}
			/>
		</QuoteSlideWrapper>
	);
};

export default BasicQuoteSlide;
